import omit from "lodash/omit"
import { Model, Schema } from "src/engine/modules/model/classes"
import memoize from "lodash/memoize"

const entityName = `constraints`

export default memoize(
  (planId, basicUrl) =>
    new Model({
      name: entityName,
      getRestUrn: (method, id) => {
        switch (method) {
          case `post`:
            return `${basicUrl}/${planId}/constraints`
          case `get`:
            return id
              ? `${basicUrl}/constraints/${id}`
              : `${basicUrl}/${planId}/constraints`
          case `put`:
          case `delete`:
            return `${basicUrl}/constraints/${id}`
          default: {
            throw new Error(`Unsupported REST method ${method}`)
          }
        }
      },
      primaryKey: `id`,
      denormalize: data => omit(data, [`id`]),
      schema: new Schema({}),
    }),
)
